var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.pageUrl
      ? _c("meta", {
          attrs: {
            itemscope: "",
            itemprop: "mainEntityOfPage",
            itemType: "https://schema.org/WebPage",
            itemid: _vm.pageUrl,
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "match-info-head-wrap" }, [
      _vm.pageHeadline
        ? _c(
            "h2",
            { staticClass: "head-title", attrs: { itemprop: "headline" } },
            [_vm._v("\n      " + _vm._s(_vm.pageHeadline) + "\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.article_mt_content
        ? _c("div", { staticClass: "meta-wrap" }, [
            _c("span", { staticClass: "meta-date meta" }, [
              _vm._v(
                _vm._s(_vm.last_updated_label) + _vm._s(_vm.article_mt_content)
              ),
            ]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.article_mt_meta
      ? _c("meta", {
          attrs: { itemprop: "dateModified", content: _vm.article_mt_meta },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.article_pt_meta
      ? _c("meta", {
          attrs: { itemprop: "datePublished", content: _vm.article_pt_meta },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        attrs: {
          itemscope: "",
          itemprop: "author",
          itemtype: "https://schema.org/Thing",
        },
      },
      [
        _c("meta", { attrs: { itemprop: "name", content: "Fantasy Gully" } }),
        _vm._v(" "),
        _c("meta", {
          attrs: {
            itemprop: "url",
            content: "https://www.youtube.com/c/FantasyGully",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        attrs: {
          itemprop: "publisher",
          itemscope: "",
          itemtype: "https://schema.org/Organization",
        },
      },
      [
        _c(
          "div",
          {
            staticStyle: { display: "none" },
            attrs: {
              itemprop: "logo",
              itemscope: "",
              itemtype: "https://schema.org/ImageObject",
            },
          },
          [
            _c("img", {
              attrs: {
                src: "https://www.fantasygully.com/static-assets/images/cssimages/logo.png",
                alt: "",
              },
            }),
            _vm._v(" "),
            _c("meta", {
              attrs: {
                itemprop: "url",
                content:
                  "https://www.fantasygully.com/static-assets/images/cssimages/logo.png",
              },
            }),
            _vm._v(" "),
            _c("meta", { attrs: { itemprop: "width", content: "156" } }),
            _vm._v(" "),
            _c("meta", { attrs: { itemprop: "height", content: "42" } }),
          ]
        ),
        _vm._v(" "),
        _c("meta", {
          attrs: { itemprop: "name", content: "Fantasy Gully Private Limited" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }